class ProductMonogrammingSummary extends window.BAO.CustomElement() {  
  setupListeners () {
    super.setupListeners()

    this.els.remove.elements.forEach(el => {
      this.listeners.add(el, 'click', this.removeMonogram.bind(this))
      
    });

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PERSONALISATION.RESET,
      this.reset.bind(this),
    )
  }

  removeMonogram (e) {
    e.preventDefault()
    const trigger = e.target.closest('button')

    const activeItems = this.els.item.elements.filter(el => el.dataset.active === 'true')

    // If only one monogram specified, reset entire form
    if (activeItems.length === 1) {
      document.querySelector(`product-monogramming`).resetForm()
      return
    }

    const index = parseInt(trigger.dataset.index)

    if (index === 1) {
      // Move second item to first item
      document.querySelector(`product-monogramming-details[data-index="1"]`).duplicate()
      document.querySelector(`product-monogramming-location[data-index="1"]`).duplicate()
    }

    // Reset second item
    document.querySelector(`product-monogramming-details[data-index="2"]`).reset()
    document.querySelector(`product-monogramming-location[data-index="2"]`).reset()
  }

  reset () {
    this.els.terms.element.checked = false
  }
}


if (!customElements.get('product-monogramming-summary')) {
  customElements.define('product-monogramming-summary', ProductMonogrammingSummary)
}
